import React, { memo } from 'react';
import type { RowDescriptor } from '@atlassian/jira-software-fast-virtual/src/services/use-virtual/index.tsx';
import CardLiteExtended from '../card-lite-extended/index.tsx';
import CardWithIccWrapper from '../card-with-icc-wrapper/index.tsx';
import { useRenderFullItem } from '../fast-virtual-list/use-render-full-item/index.tsx';

export type Props = {
	cardListId: string;
	cardId: number;
	isScrolling: boolean;
	row: RowDescriptor;
	isAttachedToParent: boolean;
	forciblyRenderRichCard?: boolean;
	setRichActiveCard: (cardId: number | null) => void;
};

const CardContainer = memo(
	({
		cardListId,
		cardId,
		isScrolling,
		row,
		isAttachedToParent,
		forciblyRenderRichCard,
		setRichActiveCard,
	}: Props) => {
		const renderFullCard = useRenderFullItem({
			isVisible: row.isVisible,
			isScrolling,
		});
		if (!renderFullCard) {
			return (
				<CardLiteExtended
					id={typeof cardId === 'string' ? parseInt(cardId, 10) : cardId}
					key={cardId}
					cardListId={cardListId}
					isAttachedToParent={isAttachedToParent}
				/>
			);
		}
		return (
			<CardWithIccWrapper
				key={cardId}
				cardId={cardId}
				cardListId={cardListId}
				isAttachedToParent={isAttachedToParent}
				forciblyRenderRichCard={forciblyRenderRichCard}
				setRichActiveCard={setRichActiveCard}
			/>
		);
	},
);

export default CardContainer;
